import { Injectable } from '@angular/core';
import { Router, type UrlTree } from '@angular/router';
import { environment } from '../../../environments/environment';

@Injectable({
    providedIn: 'root'
})
export class ShowFertirrigacionGuardService {

    constructor(public router: Router) { void Router; }

    canActivate(): boolean | UrlTree {

        if (!environment.features.activateSIEX) {
            return this.router.parseUrl('/login');
        }

        return true;
    }
}
